import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=65cb586c&scoped=true"
var script = {}
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=65cb586c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb586c",
  null
  
)

export default component.exports